let Spring = [
   [
              {
                "name": "C5",
                "midi": 72,
                "time": 0,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 0.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 0.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 0.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 1,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 1.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 1.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 1.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 2,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 2.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 2.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 2.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 3,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 3.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 3.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 3.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 4,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 4.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 4.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 4.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 5.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 5.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 5.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 6,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 6.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 6.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 6.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 7,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 7.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 7.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 7.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 8,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 8.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 8.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 8.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 9,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 9.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 9.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 9.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 10,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 10.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 10.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 10.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 11,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 11.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 11.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 11.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 12,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 12.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 12.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 12.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 13,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 13.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 13.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 13.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 14,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 14.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 14.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 14.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 15,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 15.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 15.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 15.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 16,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 16.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 16.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 16.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 17,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 17.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 17.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 17.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 18,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 18.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 18.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 18.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 19,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 19.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 19.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 19.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 20,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 20.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 20.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 20.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 21,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 21.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 21.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 21.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 22,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 22.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 22.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 22.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 23,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 23.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 23.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 23.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 24,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 24.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 24.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 24.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 25.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 25.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 25.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 26,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 26.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 26.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 26.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 27,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 27.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 27.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 27.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 28,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 28.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 28.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 28.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 29,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 29.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 29.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 29.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 30,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 30.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 30.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 30.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 31,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 31.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 31.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 31.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 32,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 32.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 32.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 32.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 33,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 33.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 33.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 33.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 34,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 34.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 34.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 34.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 35,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 35.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 35.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 35.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 36,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 36.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 36.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 36.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 37,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 37.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 37.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 37.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 38,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 38.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 38.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 38.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 39,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 39.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 39.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 39.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 40,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 40.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 40.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 40.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 41,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 41.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 41.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 41.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 42,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 42.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 42.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 42.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 43,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 43.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 43.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 43.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 44,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 44.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 44.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 44.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 45,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 45.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 45.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 45.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 46,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 46.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 46.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 46.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 47,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 47.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 47.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 47.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 48,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 48.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 48.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 48.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 49,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 49.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 49.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 49.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 50,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 50.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 50.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 50.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 51,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 51.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 51.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 51.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 52,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 52.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 52.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 52.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 53,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 53.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 53.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 53.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 54,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 54.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 54.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 54.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 55,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 55.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 55.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 55.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 56,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 56.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 56.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 56.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 57,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 57.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 57.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 57.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 58,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 58.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 58.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 58.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 59,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 59.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 59.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 59.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 60,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 60.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 60.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 60.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 61,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 61.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 61.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 61.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 62,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 62.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 62.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 62.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 63,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 63.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 63.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 63.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 64,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 64.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 64.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 64.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 65,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 65.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 65.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 65.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 66,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 66.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 66.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 66.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 67,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 67.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 67.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 67.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 68,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 68.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 68.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 68.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 69,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 69.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 69.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 69.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 70,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 70.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 70.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 70.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 71,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 71.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 71.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 71.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 72,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 72.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 72.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 72.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 73,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 73.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 73.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 73.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 74,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 74.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 74.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 74.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 75.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 75.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 75.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 76,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 76.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 76.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 76.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 77,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 77.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 77.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 77.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 78,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 78.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 78.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 78.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 79,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 79.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 79.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 79.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 80,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 80.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 80.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 80.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 81,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 81.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 81.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 81.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 82,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 82.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 82.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 82.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 83,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 83.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 83.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 83.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 84,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 84.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 84.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 84.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 85,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 85.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 85.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 85.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 86,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 86.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 86.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 86.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 87,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 87.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 87.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 87.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 88,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 88.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 88.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 88.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 89,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 89.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 89.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 89.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 90,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 90.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 90.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 90.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 91,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 91.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 91.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 91.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 92,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 92.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 92.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 92.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 93,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 93.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 93.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 93.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 94,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 94.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 94.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 94.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 96,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 96.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 96.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 96.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 97,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 97.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 97.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 97.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 98,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 98.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 98.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 98.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 100,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 100.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 100.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 100.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 101,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 101.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 101.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 101.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 102,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 102.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 102.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 102.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 103,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 103.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 103.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 103.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 104,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 104.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 104.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 104.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 105,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 105.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 105.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 105.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 106,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 106.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 106.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 106.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 107,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 107.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 107.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 107.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 108,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 108.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 108.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 108.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 109,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 109.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 109.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 109.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 110,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 110.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 110.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 110.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 111,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 111.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 111.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 111.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 112,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 112.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 112.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 112.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 113,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 113.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 113.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 113.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 114,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 114.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 114.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 114.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 115,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 115.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 115.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 115.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 116,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 116.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 116.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 116.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 117,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 117.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 117.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 117.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 118,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 118.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 118.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 118.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 119,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 119.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 119.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 119.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 120,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 120.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 120.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 120.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 121,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 121.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 121.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 121.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 122,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 122.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 122.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 122.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 123,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 123.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 123.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 123.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 124,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 124.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 124.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 124.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 125,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 125.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 125.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 125.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 126,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 126.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 126.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 126.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 127,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 127.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 127.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 127.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 128,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 128.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 128.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 128.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 129,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 129.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 129.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 129.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 130,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 130.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 130.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 130.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 131,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 131.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 131.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 131.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 132,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 132.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 132.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 132.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 133,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 133.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 133.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 133.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 134,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 134.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 134.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 134.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 135,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 135.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 135.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 135.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 136,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 136.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 136.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 136.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 137,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 137.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 137.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 137.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 138,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 138.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 138.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 138.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 139,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 139.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 139.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 139.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 140,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 140.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 140.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 140.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 141,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 141.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 141.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 141.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 142,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 142.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 142.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 142.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 143,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 143.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 143.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 143.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 144,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 144.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 144.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 144.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 145,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 145.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 145.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 145.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 146,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 146.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 146.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 146.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 147,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 147.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 147.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 147.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 148,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 148.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 148.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 148.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 149,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 149.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 149.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 149.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 150,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 150.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 150.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 150.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 151,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 151.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 151.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 151.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 152,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 152.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 152.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 152.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 153,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 153.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 153.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 153.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 154,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 154.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 154.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 154.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 155,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 155.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 155.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 155.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 156,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 156.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 156.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 156.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 157,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 157.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 157.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 157.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 158,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 158.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 158.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 158.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 159,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 159.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 159.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 159.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 160,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 160.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 160.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 160.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 161,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 161.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 161.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 161.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 162,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 162.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 162.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 162.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 163,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 163.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 163.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 163.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 164,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 164.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 164.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 164.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 165,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 165.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 165.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 165.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 166,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 166.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 166.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 166.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 167,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 167.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 167.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 167.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 168,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 168.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 168.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 168.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 169,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 169.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 169.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 169.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 170,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 170.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 170.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 170.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 171,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 171.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 171.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 171.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 172,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 172.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 172.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 172.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 173,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 173.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 173.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 173.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 174,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 174.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 174.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 174.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 175,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 175.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 175.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 175.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 176,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 176.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 176.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 176.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 177,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 177.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 177.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 177.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 178,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 178.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 178.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 178.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 179,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 179.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 179.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 179.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 180,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 180.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 180.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 180.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 181,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 181.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 181.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 181.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 182,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 182.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 182.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 182.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 183,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 183.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 183.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 183.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 184,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 184.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 184.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 184.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 185,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 185.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 185.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 185.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 186,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 186.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 186.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 186.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 187,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 187.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 187.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 187.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 188,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 188.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 188.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 188.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 189,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 189.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 189.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 189.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 190,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 190.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 190.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 190.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 191,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 191.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 191.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 191.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 192,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 192.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 192.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 192.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 193,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 193.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 193.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 193.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 194,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 194.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 194.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 194.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 195,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 195.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 195.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 195.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 196,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 196.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 196.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 196.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 197,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 197.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 197.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 197.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 199,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 199.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 199.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 199.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 200,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 200.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 200.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 200.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 202,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 202.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 202.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 202.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 203,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 203.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 203.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 203.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 205,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 205.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 205.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 205.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 206,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 206.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 206.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 206.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 208,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 208.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 208.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 208.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 209,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 209.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 209.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 209.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 211,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 211.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 211.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 211.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 212,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 212.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 212.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 212.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 214,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 214.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 214.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 214.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 215,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 215.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 215.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 215.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 216,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 216.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 216.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 216.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 217,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 217.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 217.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 217.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 218,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 218.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 218.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 218.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 220,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 220.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 220.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 220.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 221,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 221.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 221.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 221.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 222,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 222.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 222.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 222.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 223,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 223.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 223.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 223.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 224,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 224.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 224.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 224.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 225,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 225.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 225.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 225.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 226,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 226.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 226.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 226.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 227,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 227.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 227.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 227.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 228,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 228.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 228.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 228.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 229,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 229.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 229.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 229.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 230,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 230.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 230.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 230.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 231,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 231.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 231.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 231.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 232,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 232.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 232.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 232.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 233,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 233.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 233.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 233.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 234,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 234.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 234.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 234.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 235,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 235.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 235.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 235.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 236,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 236.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 236.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 236.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 237,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 237.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 237.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 237.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 238,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 238.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 238.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 238.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 239,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 239.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 239.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 239.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 240,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 240.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 240.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 240.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 241,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 241.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 241.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 241.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 242,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 242.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 242.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 242.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 243,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 243.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 243.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 243.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 244,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 244.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 244.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 244.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 245,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 245.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 245.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 245.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 246,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 246.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 246.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 246.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 247,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 247.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 247.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 247.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 248,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 248.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 248.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 248.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 249,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 249.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 249.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 249.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.25,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.5,
                "vel": 0.25196850393700787,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.75,
                "vel": 0.25196850393700787,
                "dur": 0.25
              }
            ],
            [
              {
                "name": "C4",
                "midi": 60,
                "time": 14,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 29.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 30.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 43,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 44,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 45,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 46,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 82,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 82.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 83,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 83.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 83.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 84,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 84.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 84.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 85,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 85.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 85.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 86,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 86.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 87.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 87.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 88,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 88.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 88.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 89,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 89.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 89.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 90,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 90.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 91.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 91.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 92,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 92.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 92.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 93,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 93.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 93.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 94,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 94.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 94.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 95,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 95.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 95.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 96,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 96.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 96.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 97,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 97.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 97.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 98,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 102,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 106,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 111.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 111.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 112,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 120.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 120.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 121,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 128,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 131,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 135,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 138,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 142,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 145,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 179.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 180,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 180.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 181.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 182.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 184.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 185.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 195.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 195.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 198.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 201.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 202.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 204.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 205.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 207.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 208.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 210.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 211.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 211.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 211.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 212.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 213.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 213.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 214.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 215.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 216.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 217.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 218.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 219.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 219.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 220.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 221.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 222.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 222.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 223.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 224.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 225.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 227.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 231.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 233.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 235.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 237.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 239.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 241.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 243.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 245.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 247.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 249.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 251.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 253.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 255.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              }
            ],
            [
              {
                "name": "C4",
                "midi": 60,
                "time": 17.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 94.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 100.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 100.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 100.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 104.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 104.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 112,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 115,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 119,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 122,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 126,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 129,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 133,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 133.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 135,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 135.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 137,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 137.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 139,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 139.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 141,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 141.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 143,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 143.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 145,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 145.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 166.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 167.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 179.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 181.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 182.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 184.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 185.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 187.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 190.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 194.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 197.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 197.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 200.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 200.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 201,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 201.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 203.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 203.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 203.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 203.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 204,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 204.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 206.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 206.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 206.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 206.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 209.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 209.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 209.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 209.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 212.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 214.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 218.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 220.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 222.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 224.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 226.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 228.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 230.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 232.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 234.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 236.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 238.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 240.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 242.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 244.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 246.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 248.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 250.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 252.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 254.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              }
            ],[
              {
                "name": "C4",
                "midi": 60,
                "time": 11.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 11.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 12,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 12.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 12.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 12.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 13,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 13.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 13.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 13.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 23.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 24.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 25.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 26.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 27.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 28.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 29.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 30.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.53125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 82.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 83,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 83.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 83.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 84,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 84.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 84.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 85,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 85.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 85.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 86,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 86.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 87.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 87.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 88,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 88.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 88.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 89,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 89.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 89.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 90,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 90.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 91.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 110,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 114.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 114.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 114.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 118.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 118.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 119,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 121.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 124.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 128.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 131.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 135.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 135.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 137.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 137.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 139.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 139.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 141.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 141.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 143.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 143.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 145.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 145.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 162.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 163.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 164.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 165,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 165.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 166.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 167.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 179.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 180,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 180.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 183.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 186.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 189.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 192.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 195.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 195.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 199.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 201.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 201.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 202.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 203.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 204.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 204.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 205.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 206.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 207.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 208.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 209.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 210.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 211.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 211.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 211.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 212.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 213.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 213.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 214.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 215.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 216.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 217.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 218.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 221.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 225.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 227.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 229.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 231.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 233.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 235.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 237.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 239.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 241.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 243.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 245.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 247.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 249.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 251.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 251.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 252.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 252.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 253.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 253.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 254.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 254.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 255.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 255.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              }
            ],
            [
              {
                "name": "C4",
                "midi": 60,
                "time": 12.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 12.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 13,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 13.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 13.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 13.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 23.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 24.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 25.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 26.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 27.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 28.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 29.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 30.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 66.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 79,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 83,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 100.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 100.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 101,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 105.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 109.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 110,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 112.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 115.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 119.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 122.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 126.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 129.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 133.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 133.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 135.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 135.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 137.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 137.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 139.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 139.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 141.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 141.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 143.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 143.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 145.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 145.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 145.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 145.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 146,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 146.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 146.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 146.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 146.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 146.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 146.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 146.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 148.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 150.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 150.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 162.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 163.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 164,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 164.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 165.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 166.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 167,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 178.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 180.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 181.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 183.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 184.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 186.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 189.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 192.75,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 196.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 199.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 202.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 202.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 203,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 203.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 205.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 205.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 206,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 206.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 208.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208.375,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 208.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 209,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 209.625,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 211.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 213.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 215.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 217.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 221.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 225.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 227.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 231.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 233.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 235.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 237.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 239.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 241.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 243.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 243.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 243.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 243.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 243.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 243.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 244,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 244.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 244.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 244.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 244.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 244.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 244.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 244.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 245,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 245.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 245.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 245.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 245.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 245.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 245.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 245.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 246,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 246.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 246.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 246.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 246.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 246.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 246.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 246.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 247,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 247.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 247.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 247.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 247.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 247.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 247.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 247.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 248,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 248.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 248.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 248.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 248.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 248.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 248.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 248.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 249,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 249.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 249.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 249.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 249.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 249.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 249.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 249.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 250.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 250.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 250.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 250.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 250.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 250.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 251.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 251.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 251.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 251.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 251.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 251.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 252.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 252.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 252.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 253.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 253.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 253.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 254.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 254.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 254.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 255.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 255.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              }
            ],[
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 30.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 43,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 44,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 45,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 46,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 82.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 83,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 83.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 83.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 84,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 84.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 84.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 85,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 85.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 85.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 86,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 86.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 87.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 87.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 88,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 88.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 88.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 89,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 89.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 89.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 90,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 90.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 91.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 91.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 92,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 92.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 92.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 93,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 93.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 93.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 94,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 98,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 102,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 106,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 111.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 111.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 112,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 120.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 120.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 121,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 129.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 129.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 130,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 132.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 135.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 139.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 142.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 146.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 149.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 194.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 195.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 196,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 196.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 197,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 197.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 197.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 197.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 198.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 199,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 202,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 202.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 205,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 205.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 208,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 208.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 211,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 211.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 211.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 214,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.125,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 214.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 215.375,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 217,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.125,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 217.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 218.375,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 220,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.125,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 220.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 221.375,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 223,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.125,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 223.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 224.375,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 226,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.125,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 226.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 227.375,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 229,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.125,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 229.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 230.375,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 232,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 234,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 236,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 238,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 240,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 242,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 244,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 246,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 248,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 250,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 252,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 254,
                "vel": 0.49606299212598426,
                "dur": 0.125
              }
            ], [
              {
                "name": "C4",
                "midi": 60,
                "time": 11,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 11.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 11.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 11.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 12,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 12.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 12.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 12.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 13,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 13.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 13.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 13.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 14.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 14.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 26.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 27.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 28.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 29.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 30.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 43,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 44,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 45,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 82,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 82.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 83,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 83.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 83.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 84,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 84.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 84.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 85,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 85.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 85.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 86,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 86.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 87.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 87.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 88,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 88.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 88.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 89,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 89.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 89.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 90,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 90.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 91.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 91.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 92,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 92.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 92.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 93,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 93.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 93.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 94,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 94.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 94.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 95,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 103,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 107,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 111,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 116.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 117,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 121.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 121.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 121.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 126,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 130.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 130.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 130.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 133,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 136,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 140,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 143,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 147,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 147.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 149,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 149.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 151,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 151.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 153,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 153.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 182.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 184,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 184.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 185.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 194.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 197,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 197.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 200,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 200.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 201,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 203,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 203.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 203.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 204,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 206,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 206.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 206.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 207.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 209.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 209.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 210.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 212.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 212.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 213,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 213.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 213.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 213.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 215.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 215.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 216.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 218.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 218.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 219,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 219.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 219.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 219.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 221.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 221.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 222,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 222.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 222.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 222.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 224.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 224.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 225,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 225.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 225.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 225.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 227.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 229.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 231.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 233.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 235.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 237.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 239.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 241.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 243.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 245.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 247.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 249.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 251.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 253.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 255.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              }
            ],[
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 43,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 44,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 45,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 46,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 47,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 48,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 49,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 82.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 83.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 83.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 83.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 84.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 84.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 84.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 85.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 85.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 85.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 86.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 86.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 87.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 87.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 88,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 88.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 88.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 89,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 89.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 89.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 90,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 90.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 91.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 91.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 92,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 92.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 92.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 93,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 93.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 93.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 94,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 94.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 94.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 95,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 95.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 95.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 96,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 96.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 96.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 97,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 97.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 97.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 98,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 98.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 98.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 99,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 103,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 107,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 111,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 115,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 120.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 120.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 121,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 125.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 129.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 129.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 130,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 134.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 134.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 134.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 138.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 138.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 139,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 141.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 144.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 148.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 151.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 155.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 155.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 157.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 157.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 159.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 159.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 161.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 161.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 163.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 163.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 165.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 165.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 179.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 180,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 180.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 181.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 182.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 184.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 185.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 194.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 195,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 195.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 198.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 198.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 201.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 201.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 202,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 202.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 204.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 205,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 205.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 207.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 208,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 208.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 210.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 211,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 211.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 213.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 214,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 214.25,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 216.25,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 216.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 217.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 217.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 218.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 219.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 219.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 220.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 220.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 221.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 222.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 222.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 223.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 224.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 225.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 225.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 226.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 227.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 228.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 228.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 229.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 230.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 231.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 231.875,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 232.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 232.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 232.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 233.125,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 234.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 236.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 238.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 240.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 242.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 244.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 246.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 248.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 250.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 252.75,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 254.75,
                "vel": 0.49606299212598426,
                "dur": 1.25
              }
            ],[
              {
                "name": "C4",
                "midi": 60,
                "time": 15,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 15.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 15.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 16.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 16.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 17.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 17.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 18.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 18.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 19.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 19.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 20.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 20.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 21.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 21.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 22.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 22.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 23.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 23.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 24.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 24.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 25.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 25.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.03125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 26.5,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 26.53125,
                "vel": 0.49606299212598426,
                "dur": 0.46875
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 27,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 27.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 27.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 28,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 28.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 28.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 29,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 29.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 29.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 30,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 30.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 30.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 31,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 31.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 31.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 32,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 32.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 32.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 33,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 33.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 33.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 34,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 34.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 34.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 35,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 35.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 35.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 36,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 36.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 36.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 37,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 37.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 37.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 38,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 38.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 38.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 39,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 39.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 39.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 40,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 40.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 40.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 41,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 41.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 41.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 42,
                "vel": 0.49606299212598426,
                "dur": 0.03125
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.03125,
                "vel": 0.49606299212598426,
                "dur": 0.21875
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 42.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 42.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 43.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 43.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 44.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 44.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 45.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 45.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 46.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 46.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 47.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 47.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 48.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 48.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 49.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 49.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 50.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 50.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 51.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 51.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 52.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 52.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 53.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 53.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 54.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 54.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 55.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 55.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 56.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 56.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 57.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 57.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 58.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 58.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 59.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 59.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 60.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 60.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 61.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 61.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 62.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 62.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 63.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 63.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 63.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 64.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 64.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 64.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 65.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 65.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 65.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 66.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 66.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 66.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 67.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 67.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 67.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 68.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 68.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 68.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 69.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 69.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 69.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 70.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 70.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 70.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 71.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 71.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 71.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 72.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 72.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 72.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 73.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 73.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 73.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 74.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 74.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 74.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 75.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 75.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 75.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 76.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 76.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 76.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 77.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 77.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 77.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 78.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 78.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 78.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 79.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 79.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 79.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 80.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 80.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 80.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 81.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 81.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 81.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 82.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 82.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 82.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 83,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 83.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 83.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 84,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 84.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 84.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 85,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 85.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 85.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 86,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 86.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 86.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 87,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 87.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 87.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 88,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 88.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 88.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 89,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 89.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 89.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 90,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 90.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 90.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 91,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 91.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 91.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 92,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 92.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 92.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 93,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 93.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 93.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 94,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 94.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 94.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "E4",
                "midi": 64,
                "time": 95,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 95.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 95.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 96,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 100,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 104,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 108,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 112,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 117.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 117.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 118,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 122.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 122.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 122.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 126.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 126.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 127,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 131.25,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 131.375,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 131.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 135.75,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 135.875,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "C4",
                "midi": 60,
                "time": 136,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 138.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 141.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 145.5,
                "vel": 0.49606299212598426,
                "dur": 3
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 148.5,
                "vel": 0.49606299212598426,
                "dur": 4
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 152.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 152.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 154.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 154.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 156.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 156.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 158.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 158.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 160.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 160.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 162.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 162.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 164.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 164.625,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 166.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 166.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 167.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 167.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 168.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 168.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 169.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 169.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 170.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 170.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 171.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 171.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 172.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 172.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 173.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 173.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 174.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 174.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 175.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 175.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 176.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 176.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 177.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 177.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 178.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 178.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 179.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 179.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 180.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 180.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 181.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 181.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 182,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 182.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 182.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 182.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 183.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 183.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 183.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 184.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 184.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 184.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 185,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 185.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 185.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 185.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 186.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 186.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 186.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 187.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 187.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 187.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 188.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 188.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 188.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 189.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 189.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 189.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 190.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 190.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 190.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 191.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 191.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 191.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 192.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 192.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 192.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 193.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 193.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 193.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 194,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 194.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 194.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 194.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 195.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 195.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 195.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 196.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 196.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 196.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 197,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 197.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 197.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 197.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 197.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 198.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 198.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 198.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 199.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 199.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 199.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 200,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 200.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 200.5,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.625,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 200.75,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 200.875,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 201,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 201.125,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 201.25,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 201.375,
                "vel": 0.3779527559055118,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 201.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 201.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 202,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 204,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 204.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 204.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 205,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 207,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 207.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 207.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 208,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 210,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 210.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 210.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 211,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 213,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 213.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 213.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 214,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 216,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 216.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 216.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 217,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 219,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 219.5,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 219.75,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 220,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 222,
                "vel": 0.49606299212598426,
                "dur": 0.5
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 222.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 222.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 223.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 223.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 225.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 225.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 226.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 226.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 228.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 228.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 229.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 229.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 231.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 231.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 232,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 232.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 232.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 232.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 234.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 234.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 235,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 235.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 235.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 235.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 237.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 237.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 238,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 238.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 238.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 238.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 240.5,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 240.625,
                "vel": 0.49606299212598426,
                "dur": 0.375
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 241,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "F4",
                "midi": 65,
                "time": 241.125,
                "vel": 0.49606299212598426,
                "dur": 0.125
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 241.25,
                "vel": 0.49606299212598426,
                "dur": 0.25
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 241.875,
                "vel": 0.49606299212598426,
                "dur": 1.625
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 243.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 245.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 247.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "F#4",
                "midi": 66,
                "time": 249.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "C5",
                "midi": 72,
                "time": 251.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "B4",
                "midi": 71,
                "time": 253.5,
                "vel": 0.49606299212598426,
                "dur": 2
              },
              {
                "name": "G4",
                "midi": 67,
                "time": 255.5,
                "vel": 0.49606299212598426,
                "dur": 0.5
              }
            ]
];

export default Spring;